import React from "react";

function Linkedin() {
  return (
    <div className="t-a-c">
      <div className=" h-c-v-c">
        <div className="m-t-7">Thank you for login</div>
        <a href="https://linkberry.netlify.app/invite" target="_blank">
          {" "}
          <div className="f-s-2 f-w-600 blue_clr">Click here to continue</div>
        </a>
      </div>
    </div>
  );
}

export default Linkedin;
